// roughness from a hydrant flow test: measured pressure drop (static − flowing) at a known withdrawal
// -> one k (mm) for all pipes on the flow path supply → hydrant; the drop is independent of height / supply-pressure errors
import { buildNet, simulate } from './aquaNet';

// pipes on the shortest open path from the hydrant to any supply
export function pathPipes(project, hid) {
  const net = buildNet(project, {}), adj = {};
  net.links.filter((l) => !l.closed).forEach((l) => { (adj[l.a] ||= []).push([l.b, l]); (adj[l.b] ||= []).push([l.a, l]); });
  const dist = { [hid]: 0 }, prev = {}, done = new Set(), src = new Set(net.srcIds);
  for (;;) {
    let u = null; Object.keys(dist).forEach((n) => { if (!done.has(n) && (u == null || dist[n] < dist[u])) u = n; });
    if (u == null) return [];
    if (src.has(u)) { const ids = new Set(); let n = u; while (prev[n]) { if (prev[n].l.pipeId) ids.add(prev[n].l.pipeId); n = prev[n].n; } return [...ids]; }
    done.add(u);
    (adj[u] || []).forEach(([v, l]) => { const d = dist[u] + l.len; if (dist[v] == null || d < dist[v]) { dist[v] = d; prev[v] = { n: u, l }; } });
  }
}

const withK = (project, ids, k) => ({ ...project, aqua: { ...(project.aqua || {}), hl: 'DW' }, pipes: project.pipes.map((p) => (ids.has(p.id) ? { ...p, hyd: { ...(p.hyd || {}), k } } : p)) });
async function drop(project, cfg, hid, q) {
  const o = { noHydRes: true, noHyd: true };
  const a = await simulate(project, { ...cfg, fire: null }, { ...o, hydQ: { [hid]: 0 } }), b = await simulate(project, { ...cfg, fire: null }, { ...o, hydQ: { [hid]: q } });
  const s = a.nodes?.[hid]?.bar, f = b.nodes?.[hid]?.bar;
  return Number.isFinite(s) && Number.isFinite(f) ? { stat: s, flow: f, dp: s - f } : null;
}

// bisection on log(k) between 0.005 and 20 mm (pressure drop rises with k)
export async function calibK(project, cfg, hid, q, dpMeas) {
  const list = pathPipes(project, hid), ids = new Set(list);
  if (!list.length) return { error: 'path' };
  const lo0 = await drop(withK(project, ids, 0.005), cfg, hid, q), hi0 = await drop(withK(project, ids, 20), cfg, hid, q);
  if (!lo0 || !hi0) return { error: !lo0 && !hi0 ? 'dry' : 'calc' };
  if (dpMeas <= lo0.dp) return { pipes: list, k: 0.005, low: true, dpMin: lo0.dp, dpMax: hi0.dp };
  if (dpMeas >= hi0.dp) return { pipes: list, k: 20, high: true, dpMin: lo0.dp, dpMax: hi0.dp };
  let a = Math.log(0.005), b = Math.log(20), r = null;
  for (let i = 0; i < 16; i++) {
    const m = (a + b) / 2; r = await drop(withK(project, ids, Math.exp(m)), cfg, hid, q);
    if (!r) return { error: 'calc' };
    if (r.dp < dpMeas) a = m; else b = m;
  }
  return { pipes: list, k: +Math.exp((a + b) / 2).toFixed(3), dp: r.dp, dpMin: lo0.dp, dpMax: hi0.dp };
}
